var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.245 12.1512L9.21404 21.519C7.64227 22.1849 7.65136 23.1097 8.92567 23.5221L14.8386 25.4678L28.5196 16.3631C29.1664 15.9479 29.7575 16.1713 29.2717 16.6262L18.1874 27.1777H18.1848L18.1874 27.1791L17.7795 33.6078C18.3771 33.6078 18.6408 33.3187 18.9759 32.9776L21.848 30.0317L27.822 34.6861C28.9235 35.326 29.7146 34.9972 29.9887 33.6106L33.9103 14.116C34.3117 12.4184 33.2959 11.6498 32.245 12.1512Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogoLight);
export default __webpack_public_path__ + "static/media/telegram-logo-light.d011642420a28615db7e7042acaa96c9.svg";
export { ForwardRef as ReactComponent };